/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  no-useless-catch */
import { isEmpty } from 'ramda';
import { IAddressSuggest, IMultiSuggestResult, IResultSuggestions } from '@cian/geosuggest-widget';
import { loadYmapsApi } from 'shared/utils/ymaps';

export interface IMultiSuggestParams {
  yandex: {
    apiKey: string;
    suggestApiKey: string;
    value: string;
    options?: {
      results: number;
    };
  };
}

export async function getMultiSuggest(params: IMultiSuggestParams): Promise<IMultiSuggestResult> {
  const {
    yandex: { value, apiKey, suggestApiKey },
  } = params;
  let yaSuggestResult: YMaps.ISuggestResult[] | YMaps.IScriptError | null = null;
  const suggestions: IResultSuggestions = {};

  const yandexSuggestApi = await loadYmapsApi({ require: ['suggest'] }, apiKey, suggestApiKey);

  try {
    yaSuggestResult = await yandexSuggestApi.suggest(`Россия, ${value}`);

    /** Ошибку можно поймать, отрубив интернет */
    if ('message' in yaSuggestResult) {
      throw new Error(yaSuggestResult.message);
    }
  } catch (e) {
    throw e;
  }

  if (!isEmpty(yaSuggestResult)) {
    suggestions.addresses = yaSuggestResult as IAddressSuggest[];
  }

  return {
    suggestions,
    sortOrder: ['addresses'],
  };
}
